import { filterList } from '@/utils/filterList'

export const getMagazine = ( store ) => store.magazines.magazine
export const getMagazines = ( { magazines: store } ) => store.magazines
export const getFilteredMagazines = ( store, type ) => {
  const magazines = getMagazines( store )
  return filterList( magazines, type )
}
export const getExportingPdf = store => store.magazines.exportingPdf.exporting
export const getExportedPdfs = store =>
  store.magazines.exportingPdf.exportedMagazines



// WEBPACK FOOTER //
// ./src/store/getters/magazines.js